import React, { Component } from 'react';
import {
  ModalContainer,
  ShareBarWrapper,
  BarBtn,
  BarTitle,
  BarTitleWrappper,
  CloseBtnWrapper,
  ShareBar,
  ModalIcon,
  Background,
  ContentWrapper
} from './AlertModaElement';
import { getTranslatedKey } from '../Utils/TranslateUtils';

export default class AlertModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = () => {
    document.addEventListener('keydown', this.onEscClick);
  };
  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEscClick);
  }

  onEscClick = (e) => {
    if (e.key === 'Escape') {
      this.props.toggleAlert(false);
    }
  };

  render() {
    return (
      <Background active={this.props.background}>
        <ModalContainer center={this.props.center} id="AlertContainer" altura={this.props.altura} modalOpen={true}>
          <ShareBar>
            <ShareBarWrapper>
              <BarTitleWrappper>
                <BarTitle fontSizeEnabled={this.props.fontSizeEnabled}>{this.props.title}</BarTitle>
              </BarTitleWrappper>
              <CloseBtnWrapper>
                <BarBtn
                  title={getTranslatedKey('tancar')}
                  onClick={() => this.props.toggleAlert(false)}
                  aria-label={getTranslatedKey('aria_closeModalShare')}>
                  <ModalIcon fontSizeEnabled={this.props.fontSizeEnabled} viewBox="0 0 24 24" fill="#fff">
                    <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                  </ModalIcon>
                </BarBtn>
              </CloseBtnWrapper>
            </ShareBarWrapper>
          </ShareBar>
          <ContentWrapper>{this.props.component}</ContentWrapper>
        </ModalContainer>
      </Background>
    );
  }
}
